<template>
  <div>
    <div
      class="modal fade"
      id="course-level-up-component"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-custom"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header bg-white justify-content-between align-items-center">
            <div class="flex-grow-1 w-0">
              <button type="button" class="btn btn-light text-black-50 pl-1" @click="close">
                <i class="pz-icon icon-close _sm"></i>
                关闭
              </button>
            </div>
            <h5 class="modal-title text-center">课程已升级</h5>
            <div class="flex-grow-1 w-0"></div>
          </div>
          <div class="modal-body p-0 bg-dark text-white text-center">
            <div
              class="h-full d-flex flex-column justify-content-center align-items-center overflow-hidden"
            >
              <div class="course-to-up text-center">
                <div
                  class="d-flex justify-content-center align-items-center mb-5"
                  v-if="levelUpTo === 1"
                >
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v1-0 animated fadeInDown faster"
                        style="animation-delay: 0.1s"
                      ></div>
                      <div class="award-zoom" style="animation-delay: 1.2s">
                        <div class="course-award-icon _2x _v1-1"></div>
                        <div
                          class="_17ac5n34"
                          style="right: -20px !important; top: 37px !important"
                        >
                          <svg
                            role="img"
                            aria-hidden="true"
                            class="_1w7dtjpw"
                            focusable="false"
                            width="55"
                            height="55"
                            viewBox="0 0 17 17"
                            style="animation-delay: 1.5s"
                          >
                            <path
                              fill="#ffffff"
                              d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
      3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                            />
                          </svg>
                        </div>
                        <div class="_176g09a4" style="top: 67px !important; left: 33px !important">
                          <svg
                            role="img"
                            aria-hidden="true"
                            class="_1w7dtjpw"
                            focusable="false"
                            width="22"
                            height="22"
                            viewBox="0 0 17 17"
                            style="animation-delay: 2.5s"
                          >
                            <path
                              fill="#ffffff"
                              d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
          3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.2s">
                      青铜
                    </p>
                  </div>
                  <i
                    class="pz-icon icon-enter text-white-10 mb-3 animated fadeIn faster"
                    style="animation-delay: 0.2s"
                  ></i>

                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v2-0 animated fadeInDown faster"
                        style="animation-delay: 0.3s"
                      ></div>
                    </div>
                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.4s">
                      白银
                    </p>
                  </div>
                  <i
                    class="pz-icon icon-enter text-white-10 mb-3 animated fadeIn faster"
                    style="animation-delay: 0.4s"
                  ></i>
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v3-0 animated fadeInDown faster"
                        style="animation-delay: 0.5s"
                      ></div>
                    </div>
                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.6s">
                      黄金
                    </p>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-center align-items-center mb-5"
                  v-if="levelUpTo === 2"
                >
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v1-1 animated fadeInDown faster"
                        style="animation-delay: 0.1s"
                      ></div>
                    </div>
                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.2s">
                      青铜
                    </p>
                  </div>
                  <i
                    class="pz-icon icon-enter text-white-10 mb-3 animated fadeIn faster"
                    style="animation-delay: 0.2s"
                  ></i>
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v2-0 animated fadeInDown faster"
                        style="animation-delay: 0.3s"
                      ></div>
                      <div class="award-zoom" style="animation-delay: 1.2s">
                        <div class="course-award-icon _2x _v2-1"></div>
                        <div
                          class="_17ac5n34"
                          style="right: -20px !important; top: 37px !important"
                        >
                          <svg
                            role="img"
                            aria-hidden="true"
                            class="_1w7dtjpw"
                            focusable="false"
                            width="55"
                            height="55"
                            viewBox="0 0 17 17"
                            style="animation-delay: 1.5s"
                          >
                            <path
                              fill="#ffffff"
                              d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
      3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                            />
                          </svg>
                        </div>
                        <div class="_176g09a4" style="top: 67px !important; left: 33px !important">
                          <svg
                            role="img"
                            aria-hidden="true"
                            class="_1w7dtjpw"
                            focusable="false"
                            width="22"
                            height="22"
                            viewBox="0 0 17 17"
                            style="animation-delay: 2.5s"
                          >
                            <path
                              fill="#ffffff"
                              d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
          3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>

                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.4s">
                      白银
                    </p>
                  </div>
                  <i
                    class="pz-icon icon-enter text-white-10 mb-3 animated fadeIn faster"
                    style="animation-delay: 0.4s"
                  ></i>
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v3-0 animated fadeInDown faster"
                        style="animation-delay: 0.5s"
                      ></div>
                    </div>
                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.6s">
                      黄金
                    </p>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-center align-items-center mb-5"
                  v-if="levelUpTo === 3"
                >
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v1-1 animated fadeInDown faster"
                        style="animation-delay: 0.1s"
                      ></div>
                    </div>
                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.2s">
                      青铜
                    </p>
                  </div>
                  <i
                    class="pz-icon icon-enter text-white-10 mb-3 animated fadeIn faster"
                    style="animation-delay: 0.2s"
                  ></i>
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v2-1 animated fadeInDown faster"
                        style="animation-delay: 0.3s"
                      ></div>
                    </div>

                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.4s">
                      白银
                    </p>
                  </div>
                  <i
                    class="pz-icon icon-enter text-white-10 mb-3 animated fadeIn faster"
                    style="animation-delay: 0.4s"
                  ></i>
                  <div class="text-center">
                    <div class="course-award-icon-wrapper">
                      <div
                        class="course-award-icon _2x _v3-0 animated fadeInDown faster"
                        style="animation-delay: 0.5s"
                      ></div>
                      <div class="award-zoom" style="animation-delay: 1.2s">
                        <div class="course-award-icon _2x _v3-1"></div>
                        <div
                          class="_17ac5n34"
                          style="right: -20px !important; top: 37px !important"
                        >
                          <svg
                            role="img"
                            aria-hidden="true"
                            class="_1w7dtjpw"
                            focusable="false"
                            width="55"
                            height="55"
                            viewBox="0 0 17 17"
                            style="animation-delay: 1.5s"
                          >
                            <path
                              fill="#ffffff"
                              d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
      3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                            />
                          </svg>
                        </div>
                        <div class="_176g09a4" style="top: 67px !important; left: 33px !important">
                          <svg
                            role="img"
                            aria-hidden="true"
                            class="_1w7dtjpw"
                            focusable="false"
                            width="22"
                            height="22"
                            viewBox="0 0 17 17"
                            style="animation-delay: 2.5s"
                          >
                            <path
                              fill="#ffffff"
                              d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
          3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                            />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <p class="text-white-50 animated fadeIn faster" style="animation-delay: 0.6s">
                      黄金
                    </p>
                  </div>
                </div>

                <ul class="list-inline mb-7">
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    :style="{ 'animation-delay': `0.${idx - 1}s` }"
                    :key="`book-level-master-${idx}`"
                    v-for="(book, idx) in books"
                  >
                    <i class="book-level _master" :class="`_v${levelUpTo}`"></i>
                  </li>
                  <!-- <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.2s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.3s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.4s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.5s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.6s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.7s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.8s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 0.9s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>
                  <li
                    class="list-inline-item mx-xl-2 animated bounceIn"
                    style="animation-delay: 1.0s;"
                  >
                    <i class="book-level _v1 _master"></i>
                  </li>-->
                </ul>
              </div>

              <div class="w-p50 mb-5">
                <h2 class="text-center mb-5 animated fadeInUp faster" style="animation-delay: 0.5s">
                  恭喜您！获得一枚{{ getText(levelUpTo) }}勋章！
                </h2>
                <p
                  v-if="levelUpTo < 3"
                  class="lead text-white-70 animated fadeInUp faster"
                  style="animation-delay: 0.7s"
                >
                  点击课程主页按钮，继续为下一个 · {{ getText(levelUpTo + 1) }}等级而奋斗吧！
                </p>
                <p
                  v-if="levelUpTo === 3"
                  class="lead text-white-70 animated fadeInUp faster"
                  style="animation-delay: 0.7s"
                >
                  恭喜您集齐了所有勋章！
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-white justify-content-between">
            <div class="modal-footer-left"></div>
            <div class="modal-footer-right">
              <button type="button" class="btn btn-link text-secondary btn-lg mr-5" @click="close">
                关闭
              </button>
              <button type="button" class="btn btn-primary btn-lg" @click="goBack">
                返回课程主页
              </button>
            </div>
          </div>
          <div class="course-level-up">
            <canvas style="width: 100%; height: 100%"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import { getCourseLevelText } from '../utils';

export default {
  name: 'CourseLevelUp',

  props: {
    visiable: {
      type: Boolean,
      default: () => false,
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    levelUpTo: {
      type: Number,
      default: () => 0,
    },

    books: {
      type: Array,
      default: () => [],
    },

    onGoBackToCourse: {
      type: Function,
      default: () => {},
    },
  },

  computed: {},

  watch: {
    visiable: function (v) {
      if (v) {
        $(`#course-level-up-component`).modal({
          backdrop: 'static',
          keyboard: false,
        });
      }
    },
  },

  mounted() {
    $(`#course-level-up-component`).on('hidden.bs.modal', (e) => {
      this.onClose();
    });
  },

  beforeDestroy() {
    this.close();
  },

  methods: {
    close() {
      $(`#course-level-up-component`).modal('hide');
      this.onClose();
    },

    getText(level) {
      return getCourseLevelText(level);
    },

    goBack() {
      this.close();
      this.onGoBackToCourse();
    },
  },
};
</script>
<style lang="scss" scoped>
.course-level-up {
  left: 0px !important;
  top: 0px !important;
  position: fixed !important;
  z-index: 200000 !important;
  pointer-events: none !important;
  width: 100%;
  height: 100%;
  right: 0px !important;
  bottom: 0px !important;
  -webkit-filter: Alpha(opacity=0) !important;
  filter: Alpha(opacity=0) !important;
}
</style>
